var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "custom-class": "bill-payment-dialog-by-job",
            visible: _vm.visible,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "append-to-body": _vm.appendToBody,
            "modal-append-to-body": _vm.modalAppendToBody,
            "show-close": false,
            title: _vm.title,
            width:
              !_vm.ifJc && _vm.customFields && _vm.customFields.length > 0
                ? "1350px"
                : "960px",
            top: "5vh"
          }
        },
        [
          _c(
            "div",
            { staticClass: "tabs-container" },
            [
              _c(
                "el-tabs",
                {
                  attrs: { "active-name": _vm.activeTabName },
                  on: { "tab-click": _vm.handleClick }
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_ApplicationForm"),
                        name: "applicationForm"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "app-main-inner-row",
                          staticStyle: { "padding-bottom": "0" }
                        },
                        [
                          _c(
                            "el-form",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                inline: true,
                                "label-width": "90px",
                                "label-position": "left",
                                disabled: _vm.readonly
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "app-main-inner-row",
                                  staticStyle: { "padding-bottom": "0" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { flex: "1" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "el-form-item-wrapper" },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "Payment.applicationNo"
                                                )
                                              }
                                            },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "170px" },
                                                attrs: { disabled: "disabled" },
                                                model: {
                                                  value:
                                                    _vm.billPayment
                                                      .billPaymentNo,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.billPayment,
                                                      "billPaymentNo",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "billPayment.billPaymentNo"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t("Payment.status"),
                                                "label-width": "50px"
                                              }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(_vm._s(_vm.stateText))
                                              ])
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "Payment.settleAccountsTo"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" }
                                            },
                                            [
                                              _c("cargo-advance-select", {
                                                staticStyle: { width: "170px" },
                                                attrs: {
                                                  filterable: "",
                                                  "select-type":
                                                    _vm.selectTypeNames
                                                      .basic_data_Company,
                                                  "method-params": {
                                                    customer: true
                                                  },
                                                  "default-value":
                                                    Number(
                                                      _vm.billPayment.accountId
                                                    ) || "",
                                                  "tag-name": _vm.language,
                                                  disabled: ""
                                                },
                                                on: {
                                                  parentCallBack: function(p) {
                                                    _vm.billPayment.accountId =
                                                      p.value
                                                    _vm.accountChange(p.value)
                                                  }
                                                }
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "10px",
                                                    display: "flex",
                                                    "justify-content":
                                                      "space-between"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-checkbox",
                                                    {
                                                      attrs: {
                                                        disabled:
                                                          !_vm.readonly &&
                                                          this
                                                            .settlementAgentArray
                                                            .length == 0
                                                      },
                                                      on: {
                                                        change:
                                                          _vm.cbSettlementAgentChange
                                                      },
                                                      model: {
                                                        value: _vm.agentChecked,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.agentChecked = $$v
                                                        },
                                                        expression:
                                                          "agentChecked"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "Payment.bySettlementAgent"
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  ),
                                                  _c("cargo-advance-select", {
                                                    staticStyle: {
                                                      "margin-left": "10px"
                                                    },
                                                    attrs: {
                                                      filterable: "",
                                                      "select-type":
                                                        _vm.selectTypeNames
                                                          .basic_data_Company,
                                                      "default-value":
                                                        Number(
                                                          _vm.billPayment
                                                            .settlementAgentId
                                                        ) === 0
                                                          ? ""
                                                          : Number(
                                                              _vm.billPayment
                                                                .settlementAgentId
                                                            ),
                                                      disabled: !_vm.agentChecked,
                                                      cache: false,
                                                      "tag-name": _vm.language,
                                                      "static-options":
                                                        _vm.settlementAgentArray
                                                    },
                                                    on: {
                                                      parentCallBack: function(
                                                        p
                                                      ) {
                                                        _vm.billPayment.settlementAgentId =
                                                          p.value
                                                        _vm.settlementAgentChange()
                                                      }
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "el-form-item-wrapper" },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "Partners.paymentType"
                                                )
                                              }
                                            },
                                            [
                                              _c("cargo-advance-select", {
                                                staticStyle: { width: "170px" },
                                                attrs: {
                                                  no: "paymentType",
                                                  filterable: "",
                                                  "select-type":
                                                    _vm.selectTypeNames
                                                      .basic_data_PaymentType,
                                                  "default-value":
                                                    _vm.billPayment.paymentType,
                                                  "tag-name": "name"
                                                },
                                                on: {
                                                  parentCallBack: function(p) {
                                                    _vm.billPayment.paymentType =
                                                      p.value
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          !_vm.ifJc
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    required: "",
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_OurHeader"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("cargo-advance-select", {
                                                    attrs: {
                                                      no: "ourTitle",
                                                      "select-type":
                                                        _vm.selectTypeNames
                                                          .static_data_InvoiceTitle,
                                                      filterable: "",
                                                      cache: false,
                                                      "default-value":
                                                        _vm.billPayment
                                                          .ourTitle,
                                                      "static-options":
                                                        _vm.ourInvoiceTitleArray
                                                    },
                                                    on: {
                                                      parentCallBack:
                                                        _vm.ourTitleChangeEvent
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "Payment.businessType"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "el-checkbox-group",
                                            {
                                              staticClass:
                                                "job-types-checkbox-group",
                                              attrs: { disabled: "" },
                                              model: {
                                                value: _vm.jobTypes,
                                                callback: function($$v) {
                                                  _vm.jobTypes = $$v
                                                },
                                                expression: "jobTypes"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-checkbox",
                                                { attrs: { label: "SE" } },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Payment.oceanExport"
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "el-checkbox",
                                                { attrs: { label: "SI" } },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Payment.oceanImport"
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "el-checkbox",
                                                { attrs: { label: "AE" } },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Payment.airExport"
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "el-checkbox",
                                                { attrs: { label: "AI" } },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Payment.airImport"
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "el-checkbox",
                                                { attrs: { label: "RE" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_RailwayExport"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "el-checkbox",
                                                { attrs: { label: "RI" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_RailwayImport"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "el-checkbox",
                                                { attrs: { label: "IE" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_IntegratedJob"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "el-checkbox",
                                                { attrs: { label: "FBA" } },
                                                [_vm._v("FBA")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "el-form-item-wrapper" },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "CargoMsg.Cargo_CurrencyOfPayment"
                                                )
                                              }
                                            },
                                            [
                                              _c("cargo-advance-select", {
                                                staticStyle: { width: "115px" },
                                                attrs: {
                                                  filterable: "",
                                                  clearable: false,
                                                  "select-type":
                                                    _vm.selectTypeNames
                                                      .basic_data_Currency,
                                                  "default-value":
                                                    _vm.billPayment.currency
                                                },
                                                on: {
                                                  parentCallBack: function(p) {
                                                    return _vm.currencyChange(
                                                      p.value,
                                                      true
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          !_vm.billPayment.rateByCharge &&
                                          _vm.ifHistoryPayment
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.rateLabel
                                                  }
                                                },
                                                [
                                                  _c("num-input", {
                                                    staticStyle: {
                                                      width: "120px"
                                                    },
                                                    attrs: {
                                                      min: 0,
                                                      max: 999999999,
                                                      precision: 8,
                                                      "truncated-precision":
                                                        _vm.exchangeRatePrecision
                                                    },
                                                    on: {
                                                      blur: _vm.rateVerify,
                                                      change: _vm.rateChange
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.billPayment.rate,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.billPayment,
                                                          "rate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "billPayment.rate"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t("Payment.amount"),
                                                "label-width": "50px"
                                              }
                                            },
                                            [
                                              _c("el-input-number", {
                                                staticStyle: { width: "115px" },
                                                attrs: {
                                                  precision: _vm.billPayment
                                                    .amount
                                                    ? 2
                                                    : 0,
                                                  controls: false,
                                                  disabled: ""
                                                },
                                                model: {
                                                  value: _vm.billPayment.amount,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.billPayment,
                                                      "amount",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "billPayment.amount"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: this.showWhtTax,
                                                  expression: "this.showWhtTax"
                                                }
                                              ],
                                              attrs: {
                                                label: _vm.$t(
                                                  "FinanceManage.charge_notWhtAmount"
                                                ),
                                                "label-width": "80px"
                                              }
                                            },
                                            [
                                              _c("el-input-number", {
                                                staticStyle: { width: "115px" },
                                                attrs: {
                                                  precision: _vm.billPayment
                                                    .chargeNotWhtAmount
                                                    ? 2
                                                    : 0,
                                                  disabled: "",
                                                  controls: false
                                                },
                                                model: {
                                                  value:
                                                    _vm.billPayment
                                                      .chargeNotWhtAmount,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.billPayment,
                                                      "chargeNotWhtAmount",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "billPayment.chargeNotWhtAmount"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "el-form-item-wrapper" },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "Payment.paymentPeriod"
                                                )
                                              }
                                            },
                                            [
                                              _c("el-date-picker", {
                                                staticStyle: { width: "170px" },
                                                attrs: {
                                                  type: "date",
                                                  clearable: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.billPayment.deadline,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.billPayment,
                                                      "deadline",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "billPayment.deadline"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "Payment.methodOfPayment"
                                                )
                                              }
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "170px"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.billPayment.payType,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.billPayment,
                                                        "payType",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "billPayment.payType"
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.receiveTypes,
                                                  function(item, index) {
                                                    return _c("el-option", {
                                                      key: index,
                                                      attrs: {
                                                        label:
                                                          _vm.$store.getters
                                                            .language === "zh"
                                                            ? item.chineseName
                                                            : item.englishName,
                                                        value: Number(item.code)
                                                      }
                                                    })
                                                  }
                                                ),
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "el-form-item-wrapper" },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "Payment.invoiceHeader"
                                                )
                                              }
                                            },
                                            [
                                              _vm.showInvoiceTitle
                                                ? _c("cargo-advance-select", {
                                                    staticStyle: {
                                                      width: "170px"
                                                    },
                                                    attrs: {
                                                      no: "11",
                                                      "allow-create": true,
                                                      "select-type":
                                                        _vm.selectTypeNames
                                                          .static_data_Title,
                                                      filterable: "",
                                                      cache: false,
                                                      "default-value":
                                                        _vm.billPayment
                                                          .invoiceTitle,
                                                      "static-options":
                                                        _vm.titleArray,
                                                      "tag-name": "title",
                                                      "tag-value": "title"
                                                    },
                                                    on: {
                                                      parentCallBack:
                                                        _vm.invoiceTitleChange
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            { staticClass: "custom-textarea" },
                                            [
                                              _c(
                                                "template",
                                                { slot: "label" },
                                                [
                                                  _vm.isSpecialExpensePaymentType
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            color: "red"
                                                          }
                                                        },
                                                        [_vm._v("*")]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Payment.replaceInvoiceRemark"
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              ),
                                              _c("el-input", {
                                                staticStyle: { width: "170px" },
                                                model: {
                                                  value:
                                                    _vm.billPayment
                                                      .replaceInvoiceRemark,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.billPayment,
                                                      "replaceInvoiceRemark",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "billPayment.replaceInvoiceRemark"
                                                }
                                              })
                                            ],
                                            2
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "el-form-item-wrapper" },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "Payment.bankOfDeposit"
                                                )
                                              }
                                            },
                                            [
                                              _c("cargo-advance-select", {
                                                staticStyle: { width: "170px" },
                                                attrs: {
                                                  filterable: "",
                                                  "select-type":
                                                    _vm.selectTypeNames
                                                      .static_data_TitleBank,
                                                  "default-value":
                                                    _vm.billPayment.buyerBank,
                                                  cache: false,
                                                  "static-options":
                                                    _vm.buyerBankArray,
                                                  "tag-value": "bank",
                                                  "tag-name": "bank",
                                                  "allow-create": true
                                                },
                                                on: {
                                                  parentCallBack:
                                                    _vm.titleBankChange
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "Payment.bankAccount"
                                                )
                                              }
                                            },
                                            [
                                              _c("cargo-advance-select", {
                                                key:
                                                  _vm.buyerBankAccountSelectKey,
                                                staticStyle: { width: "170px" },
                                                attrs: {
                                                  filterable: "",
                                                  "select-type":
                                                    _vm.selectTypeNames
                                                      .static_data_TitleBank,
                                                  "default-value":
                                                    _vm.billPayment
                                                      .buyerBankAccount,
                                                  cache: false,
                                                  "static-options":
                                                    _vm.buyerBankAccountArray,
                                                  "tag-value": "bankAccount",
                                                  "tag-name": "bankAccount",
                                                  "allow-create": true
                                                },
                                                on: {
                                                  parentCallBack:
                                                    _vm.buyerBankAccountChange
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "el-form-item-wrapper" },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "Payment.applicant"
                                                )
                                              }
                                            },
                                            [
                                              _c("cargo-advance-select", {
                                                staticStyle: { width: "170px" },
                                                attrs: {
                                                  "select-type":
                                                    _vm.selectTypeNames
                                                      .basic_data_User,
                                                  "default-value":
                                                    Number(
                                                      _vm.billPayment.inputBy
                                                    ) || "",
                                                  disabled: ""
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "Payment.dateOfApplication"
                                                )
                                              }
                                            },
                                            [
                                              _c("el-date-picker", {
                                                staticStyle: { width: "170px" },
                                                attrs: {
                                                  type: "date",
                                                  clearable: false
                                                },
                                                model: {
                                                  value:
                                                    _vm.billPayment.inputDate,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.billPayment,
                                                      "inputDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "billPayment.inputDate"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm.showEnterpriseWechatFields
                                        ? _vm._l(
                                            _vm.enterpriseWechatSelectFieldRows,
                                            function(row, rowIndex) {
                                              return _c(
                                                "div",
                                                {
                                                  key:
                                                    "enterprise-wechat-select-row-" +
                                                    rowIndex,
                                                  staticClass:
                                                    "el-form-item-wrapper"
                                                },
                                                _vm._l(row, function(field) {
                                                  return _c(
                                                    "el-form-item",
                                                    {
                                                      key: field.prop,
                                                      attrs: {
                                                        label: _vm.getEnterpriseWechatLabel(
                                                          field
                                                        ),
                                                        "label-width": "90px"
                                                      }
                                                    },
                                                    [
                                                      field.type === "text"
                                                        ? _c("el-input", {
                                                            style: {
                                                              width: "170px"
                                                            },
                                                            attrs: {
                                                              disabled: !!field.disabled
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.billPayment[
                                                                  field.prop
                                                                ],
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.billPayment,
                                                                  field.prop,
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "billPayment[field.prop]"
                                                            }
                                                          })
                                                        : _c(
                                                            "cargo-advance-select",
                                                            {
                                                              style: {
                                                                width: "170px"
                                                              },
                                                              attrs: {
                                                                "default-value":
                                                                  _vm
                                                                    .billPayment[
                                                                    field.prop
                                                                  ],
                                                                "static-options":
                                                                  field.options,
                                                                filterable: "",
                                                                "filter-type":
                                                                  "global",
                                                                "filter-tag-names":
                                                                  field.prop ===
                                                                  "waterNotifier"
                                                                    ? [
                                                                        "label",
                                                                        "userName",
                                                                        "chineseName",
                                                                        "englishName"
                                                                      ]
                                                                    : ["label"],
                                                                cache: false,
                                                                "tag-name":
                                                                  "label",
                                                                "tag-value":
                                                                  "value",
                                                                disabled: !!field.disabled
                                                              },
                                                              on: {
                                                                parentCallBack: function(
                                                                  p
                                                                ) {
                                                                  return _vm.handleEnterpriseWechatSelectCallback(
                                                                    field,
                                                                    p
                                                                  )
                                                                }
                                                              }
                                                            }
                                                          )
                                                    ],
                                                    1
                                                  )
                                                }),
                                                1
                                              )
                                            }
                                          )
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        { staticClass: "el-form-item-wrapper" },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              staticStyle: {
                                                "margin-bottom": "0 !important"
                                              },
                                              attrs: { label: "" }
                                            },
                                            [
                                              _c(
                                                "el-checkbox",
                                                {
                                                  attrs: {
                                                    no: "syncInvoiceAttachment"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.billPayment
                                                        .syncInvoiceAttachment,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.billPayment,
                                                        "syncInvoiceAttachment",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "billPayment.syncInvoiceAttachment"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "CargoMsg.Cargo_SyncInvoiceAttachment"
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  ),
                                  _c(
                                    "div",
                                    { staticStyle: { width: "290px" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "el-form-item-wrapper" },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              staticClass: "custom-textarea",
                                              attrs: {
                                                label: _vm.$t(
                                                  "Payment.invoiceNumber"
                                                ),
                                                "label-width": "100px"
                                              }
                                            },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "290px" },
                                                attrs: {
                                                  type: "textarea",
                                                  rows: 6
                                                },
                                                model: {
                                                  value:
                                                    _vm.billPayment
                                                      .invoiceNumber,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.billPayment,
                                                      "invoiceNumber",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "billPayment.invoiceNumber"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              staticClass: "custom-textarea",
                                              attrs: {
                                                label: _vm.$t(
                                                  "Payment.remarks"
                                                ),
                                                "label-width": "100px"
                                              }
                                            },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "290px" },
                                                attrs: {
                                                  type: "textarea",
                                                  rows: 6
                                                },
                                                model: {
                                                  value: _vm.billPayment.remark,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.billPayment,
                                                      "remark",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "billPayment.remark"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              staticClass: "custom-textarea",
                                              attrs: {
                                                label: _vm.$t(
                                                  "CargoMsg.Cargo_PaymentReason"
                                                ),
                                                "label-width": "100px"
                                              }
                                            },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "290px" },
                                                attrs: {
                                                  no: "paymentInstructions",
                                                  type: "textarea",
                                                  rows: 5
                                                },
                                                model: {
                                                  value:
                                                    _vm.billPayment
                                                      .paymentInstructions,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.billPayment,
                                                      "paymentInstructions",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "billPayment.paymentInstructions"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  !_vm.ifJc &&
                                  _vm.customFields &&
                                  _vm.customFields.length > 0
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            width: "340px",
                                            height: "400px",
                                            "margin-left": "52px"
                                          }
                                        },
                                        _vm._l(_vm.customFields, function(
                                          customField,
                                          index
                                        ) {
                                          return _c(
                                            "el-form-item",
                                            {
                                              key: index,
                                              staticStyle: {
                                                "margin-left": "15px",
                                                "margin-right": "0"
                                              },
                                              attrs: {
                                                label: _vm.isZh
                                                  ? customField.chineseName
                                                  : customField.englishName,
                                                "label-width": "120px"
                                              }
                                            },
                                            [
                                              customField.widgetType ===
                                              _vm.SystemConstants
                                                .WIDGET_TYPE_TEXTBOX.code
                                                ? _c("el-input", {
                                                    staticStyle: {
                                                      width: "205px"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.billPayment[
                                                          _vm.SystemConstants.CUSTOM_FIELDS_PAYMENT_REQUEST_MAP.get(
                                                            customField.fieldCode
                                                          )
                                                        ],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.billPayment,
                                                          _vm.SystemConstants.CUSTOM_FIELDS_PAYMENT_REQUEST_MAP.get(
                                                            customField.fieldCode
                                                          ),
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "billPayment[SystemConstants.CUSTOM_FIELDS_PAYMENT_REQUEST_MAP.get(customField.fieldCode)]"
                                                    }
                                                  })
                                                : _vm._e(),
                                              customField.widgetType ===
                                              _vm.SystemConstants
                                                .WIDGET_TYPE_DROPDOWN.code
                                                ? _c("cargo-advance-select", {
                                                    staticStyle: {
                                                      width: "205px"
                                                    },
                                                    attrs: {
                                                      "default-value":
                                                        _vm.billPayment[
                                                          _vm.SystemConstants.CUSTOM_FIELDS_PAYMENT_REQUEST_MAP.get(
                                                            customField.fieldCode
                                                          )
                                                        ],
                                                      "static-options":
                                                        customField.enums,
                                                      filterable: "",
                                                      cache: false,
                                                      "tag-name": "tagName",
                                                      "tag-value": "tagValue"
                                                    },
                                                    on: {
                                                      parentCallBack: function(
                                                        p
                                                      ) {
                                                        _vm.billPayment[
                                                          _vm.SystemConstants.CUSTOM_FIELDS_PAYMENT_REQUEST_MAP.get(
                                                            customField.fieldCode
                                                          )
                                                        ] = p ? p.tagValue : ""
                                                      }
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        }),
                                        1
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm.readonly
                        ? _c(
                            "div",
                            { staticClass: "reconciliation-mode-top" },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  attrs: { no: "reconciliationMode" },
                                  on: {
                                    change: _vm.reconciliationTypeChangeHandler
                                  },
                                  model: {
                                    value: _vm.reconciliationType,
                                    callback: function($$v) {
                                      _vm.reconciliationType = $$v
                                    },
                                    expression: "reconciliationType"
                                  }
                                },
                                [
                                  _c(
                                    "el-radio",
                                    {
                                      attrs: { no: "viewedByJob", label: "job" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("CargoMsg.Cargo_ViewedByJob")
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-radio",
                                    {
                                      staticStyle: { "margin-right": "10px" },
                                      attrs: {
                                        no: "viewedByFee",
                                        label: "charge"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("CargoMsg.Cargo_ViewedByFee")
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticStyle: { "padding-top": "0" } },
                        [
                          _c("cargo-ag-grid", {
                            staticStyle: {
                              width: "100%",
                              "min-height": "180px"
                            },
                            attrs: {
                              "config-module": "190804",
                              "grid-params": _vm.gridParams,
                              "grid-options": _vm.gridOptions,
                              "column-defs": _vm.columnDefs,
                              "row-data": _vm.rowData
                            },
                            on: {
                              "update:gridParams": function($event) {
                                _vm.gridParams = $event
                              },
                              "update:grid-params": function($event) {
                                _vm.gridParams = $event
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "margin-top": "10px",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-wrap": "wrap",
                                "justify-content": "flex-start",
                                "align-items": "center"
                              }
                            },
                            [
                              _c(
                                "el-form",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between",
                                    "align-items": "center"
                                  },
                                  attrs: {
                                    inline: true,
                                    "label-width": "40px",
                                    "label-position": "right"
                                  }
                                },
                                [
                                  _vm.billPayment.currency1 &&
                                  !_vm.ifHistoryPayment &&
                                  !_vm.billPayment.rateByCharge
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "vertical-align": "middle"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("Invoice.invoice_currency")
                                            ) + " "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.billPayment.currency1 &&
                                  !_vm.ifHistoryPayment &&
                                  !_vm.billPayment.rateByCharge
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                            "vertical-align": "middle"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.billPayment.currency1)
                                          ),
                                          _c("i", {
                                            staticClass: "el-icon-right"
                                          }),
                                          _vm._v(
                                            _vm._s(_vm.billPayment.currency)
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.billPayment.currency1 &&
                                  !_vm.ifHistoryPayment &&
                                  !_vm.billPayment.rateByCharge
                                    ? _c(
                                        "el-form-item",
                                        {
                                          staticStyle: {
                                            "margin-bottom": "0 !important",
                                            "margin-right": "5px"
                                          },
                                          attrs: {
                                            label: _vm.$t(
                                              "Invoice.invoice_exchangeRate"
                                            ),
                                            "label-width": _vm.$selectByLang(
                                              "",
                                              "95px"
                                            )
                                          }
                                        },
                                        [
                                          _c("num-input", {
                                            staticStyle: { width: "95px" },
                                            attrs: {
                                              disabled:
                                                _vm.billPayment.currency1 ===
                                                  _vm.billPayment.currency ||
                                                _vm.billPayment
                                                  .payByBillingRate,
                                              no: "rate1",
                                              precision: 8,
                                              "truncated-precision":
                                                _vm.rate1Precision
                                            },
                                            on: {
                                              change: function(p) {
                                                _vm.currencyRateChanged(
                                                  p,
                                                  "currency1"
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.billPayment.rate1,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billPayment,
                                                  "rate1",
                                                  $$v
                                                )
                                              },
                                              expression: "billPayment.rate1"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.billPayment.currency2 &&
                                  !_vm.ifHistoryPayment &&
                                  !_vm.billPayment.rateByCharge
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "vertical-align": "middle"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("Invoice.invoice_currency")
                                            ) + " "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.billPayment.currency2 &&
                                  !_vm.ifHistoryPayment &&
                                  !_vm.billPayment.rateByCharge
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                            "vertical-align": "middle"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.billPayment.currency2)
                                          ),
                                          _c("i", {
                                            staticClass: "el-icon-right"
                                          }),
                                          _vm._v(
                                            _vm._s(_vm.billPayment.currency)
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.billPayment.currency2 &&
                                  !_vm.ifHistoryPayment &&
                                  !_vm.billPayment.rateByCharge
                                    ? _c(
                                        "el-form-item",
                                        {
                                          staticStyle: {
                                            "margin-bottom": "0 !important",
                                            "margin-right": "5px"
                                          },
                                          attrs: {
                                            label: _vm.$t(
                                              "Invoice.invoice_exchangeRate"
                                            ),
                                            "label-width": _vm.$selectByLang(
                                              "",
                                              "95px"
                                            )
                                          }
                                        },
                                        [
                                          _c("num-input", {
                                            staticStyle: { width: "95px" },
                                            attrs: {
                                              disabled:
                                                _vm.billPayment.currency2 ===
                                                  _vm.billPayment.currency ||
                                                _vm.billPayment
                                                  .payByBillingRate,
                                              no: "rate2",
                                              precision: 8,
                                              "truncated-precision":
                                                _vm.rate2Precision
                                            },
                                            on: {
                                              change: function(p) {
                                                _vm.currencyRateChanged(
                                                  p,
                                                  "currency2"
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.billPayment.rate2,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billPayment,
                                                  "rate2",
                                                  $$v
                                                )
                                              },
                                              expression: "billPayment.rate2"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.billPayment.currency3 &&
                                  !_vm.ifHistoryPayment &&
                                  !_vm.billPayment.rateByCharge
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "vertical-align": "middle"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("Invoice.invoice_currency")
                                            ) + " "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.billPayment.currency3 &&
                                  !_vm.ifHistoryPayment &&
                                  !_vm.billPayment.rateByCharge
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                            "vertical-align": "middle"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.billPayment.currency3)
                                          ),
                                          _c("i", {
                                            staticClass: "el-icon-right"
                                          }),
                                          _vm._v(
                                            _vm._s(_vm.billPayment.currency)
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.billPayment.currency3 &&
                                  !_vm.ifHistoryPayment &&
                                  !_vm.billPayment.rateByCharge
                                    ? _c(
                                        "el-form-item",
                                        {
                                          staticStyle: {
                                            "margin-bottom": "0 !important",
                                            "margin-right": "5px"
                                          },
                                          attrs: {
                                            label: _vm.$t(
                                              "Invoice.invoice_exchangeRate"
                                            ),
                                            "label-width": _vm.$selectByLang(
                                              "",
                                              "95px"
                                            )
                                          }
                                        },
                                        [
                                          _c("num-input", {
                                            staticStyle: { width: "95px" },
                                            attrs: {
                                              disabled:
                                                _vm.billPayment.currency3 ===
                                                  _vm.billPayment.currency ||
                                                _vm.billPayment
                                                  .payByBillingRate,
                                              no: "rate3",
                                              precision: 8,
                                              "truncated-precision":
                                                _vm.rate3Precision
                                            },
                                            on: {
                                              change: function(p) {
                                                _vm.currencyRateChanged(
                                                  p,
                                                  "currency3"
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.billPayment.rate3,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billPayment,
                                                  "rate3",
                                                  $$v
                                                )
                                              },
                                              expression: "billPayment.rate3"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticStyle: {
                                        "margin-bottom": "0 !important",
                                        "margin-right": "5px"
                                      },
                                      attrs: { label: "" }
                                    },
                                    [
                                      !_vm.ifHistoryPayment &&
                                      !_vm.billPayment.rateByCharge
                                        ? _c(
                                            "el-checkbox",
                                            {
                                              attrs: {
                                                disabled: !_vm.canUseBillingRate,
                                                no: "payByBillingRate"
                                              },
                                              on: {
                                                change:
                                                  _vm.payByBillingRateChanged
                                              },
                                              model: {
                                                value:
                                                  _vm.billPayment
                                                    .payByBillingRate,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.billPayment,
                                                    "payByBillingRate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "billPayment.payByBillingRate"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_PayByBillingRate"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticStyle: {
                                        "margin-bottom": "0 !important"
                                      },
                                      attrs: { label: "" }
                                    },
                                    [
                                      _vm.showRateByCharge
                                        ? _c(
                                            "el-checkbox",
                                            {
                                              attrs: { no: "rateByCharge" },
                                              on: {
                                                change: _vm.rateByChargeChanged
                                              },
                                              model: {
                                                value:
                                                  _vm.billPayment.rateByCharge,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.billPayment,
                                                    "rateByCharge",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "billPayment.rateByCharge"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "WriteOff.rateByCharge"
                                                  ) +
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_Create"
                                                    )
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "margin-top": "10px",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-wrap": "wrap",
                                "justify-content": "flex-start",
                                "align-items": "center"
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("Payment.total")))
                              ]),
                              _c("charge-currency-total-group", {
                                key: 1,
                                attrs: {
                                  "ar-field": "chargeReceivable",
                                  "data-field":
                                    _vm.reconciliationType === "charge"
                                      ? "chargeAmount"
                                      : "chargeAmounts",
                                  "currency-field": "chargeCurrency",
                                  "rate-field": "chargeRate",
                                  "arap-order": "ap",
                                  type: "auto",
                                  "data-provider": _vm.rowData
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  ),
                  _vm.billPayment.uuid
                    ? _c(
                        "el-tab-pane",
                        {
                          staticStyle: { height: "503px" },
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_FileHistory"),
                            name: "fileHistory",
                            lazy: true
                          }
                        },
                        [
                          _c("file-history", {
                            attrs: {
                              "bill-payment-uuid": _vm.curBillPaymentUuid,
                              uuid: _vm.curBillPaymentUuid,
                              state: _vm.billPayment.state,
                              "input-by": _vm.$store.getters.userId,
                              "grid-height": "477px",
                              "module-name": "billPayment"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
            _vm.activeTabName === "applicationForm" &&
            _vm.billPayment.state == 0
              ? _c(
                  "span",
                  { staticStyle: { position: "absolute", left: "20px" } },
                  [
                    _vm.activeTabName === "applicationForm" &&
                    _vm.billPayment.uuid &&
                    _vm.billPayment.state == 0
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.addCharge }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("Payment.addCharge")) + " "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.activeTabName === "applicationForm" &&
                    _vm.billPayment.state == 0
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.removeCharge }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("Payment.removeCharge")) + " "
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "span",
              { staticStyle: { "padding-right": "10px" } },
              [
                _vm.activeTabName === "applicationForm" && !_vm.billPayment.uuid
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.toPreStep }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("Payment.back")) + " ")]
                    )
                  : _vm._e(),
                _vm.activeTabName === "applicationForm" && _vm.billPayment.uuid
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.doPrint }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("Payment.print")) + " ")]
                    )
                  : _vm._e(),
                _vm.billPayment.uuid
                  ? _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.$checkPermission([
                              "button_fmBillPaymentByJob_billPaymentHandle"
                            ]),
                            expression:
                              "$checkPermission(['button_fmBillPaymentByJob_billPaymentHandle'])"
                          }
                        ],
                        attrs: { type: "primary" },
                        on: { click: _vm.processPaymentRequest }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("Payment.processPaymentRequest")) +
                            " "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.billPayment.uuid && _vm.billPayment.state == 0
                  ? _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          loading: _vm.commitSubmitting,
                          disabled: _vm.commitSubmitting
                        },
                        on: { click: _vm.doCommitPre }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("Payment.submit")) + " ")]
                    )
                  : _vm._e(),
                _vm.$checkPermission([
                  "button_fmBillPaymentByJob_invoicePoolHandle"
                ])
                  ? _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          disabled: _vm.readonly || _vm.btnSaveEnable
                        },
                        on: { click: _vm.showInvoicePoolDialog }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("CargoMsg.Cargo_InvoicePoolReceiving")
                            ) +
                            " "
                        )
                      ]
                    )
                  : _vm._e(),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      disabled: _vm.readonly || _vm.btnSaveEnable
                    },
                    on: { click: _vm.doSavePre }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("Payment.save")) + " ")]
                ),
                _c("el-button", { on: { click: _vm.cancel } }, [
                  _vm._v(_vm._s(_vm.$t("Payment.cancel")))
                ])
              ],
              1
            )
          ]),
          _c("cargo-template-selector-dialog", {
            attrs: {
              visible: _vm.templateSelectorDialog.visible,
              ctx: _vm.templateSelectorDialog.cxt,
              category: _vm.templateSelectorDialog.category,
              data: _vm.templateSelectorDialog.data
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
              },
              selectedTemplate: _vm.updatePrintField
            }
          }),
          _vm.joinChargeDialog.visible
            ? _c("join-charge-dialog", {
                attrs: {
                  visible: _vm.joinChargeDialog.visible,
                  "search-item-module": "5043",
                  "default-conditions": _vm.joinChargeDialog.addChargeCondition,
                  "charge-state-param": "BillPaymentChargeState"
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.joinChargeDialog, "visible", $event)
                  },
                  addChargeCallBackEvent: _vm.addChargeCallBack
                }
              })
            : _vm._e(),
          _vm.invoicePoolDialog.visible
            ? _c("invoice-pool-dialog", {
                attrs: {
                  visible: _vm.invoicePoolDialog.visible,
                  "seller-tax-name-default-value":
                    _vm.invoicePoolDialog.sellerTaxNameDefaultValue,
                  "selected-entities": _vm.invoicePoolDialog.selectedEntities,
                  "make-invoice-method":
                    _vm.invoicePoolDialog.makeInvoiceMethod,
                  source: _vm.invoicePoolDialog.source,
                  operation: _vm.invoicePoolDialog.operation,
                  callback: _vm.invoicePoolCallBack
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.invoicePoolDialog, "visible", $event)
                  }
                }
              })
            : _vm._e(),
          _vm.workFlowApplyDialog.visible
            ? _c("bill-payment-work-flow-apply-dialog", {
                attrs: {
                  visible: _vm.workFlowApplyDialog.visible,
                  "bill-payment": _vm.billPayment,
                  title: _vm.$t(
                    "CargoMsg.Cargo_SubmitAPaymentRequestForApproval"
                  ),
                  type: "apply",
                  "show-wht": _vm.showWht
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.workFlowApplyDialog, "visible", $event)
                  },
                  close: function($event) {
                    _vm.workFlowApplyDialog.visible = false
                  },
                  closeAndRefresh: _vm.applyCloseAndRefresh
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm.batchCheckingWindow.visible
        ? _c("batch-checking-window", {
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              lob: _vm.batchCheckingWindow.lob,
              jobs: _vm.batchCheckingWindow.jobs,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "bill-payments": _vm.batchCheckingWindow.billPayments,
              "call-back": _vm.batchCheckingWindow.callBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "make-invoice-step-two-split-charge-dialog",
          attrs: {
            visible: _vm.splitChargeDialog.show,
            title: _vm.$t("CargoMsg.Cargo_Sp31"),
            width: "760px",
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.splitChargeDialog, "show", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                inline: true,
                model: _vm.splitChargeDialog.splitChargeForm,
                "label-width": "70px",
                "label-position": "right"
              }
            },
            [
              _c(
                "div",
                { staticClass: "el-form-item-wrapper" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_OriginalExpenseP")
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.splitChargeDialog.charge.chargeName))
                      ])
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_CurrencyP") } },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.splitChargeDialog.charge.currency))
                      ])
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_TaxIncludedPriceP")
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.splitChargeDialog.charge.amount))
                      ])
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "el-form-item-wrapper" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_SplitExpenseP") }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.splitChargeDialog.splitCharge.chargeName)
                        )
                      ])
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_CurrencyP") } },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.splitChargeDialog.splitCharge.currency)
                        )
                      ])
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item-w",
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_TaxIncludedPriceP")
                      }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "amount",
                          precision: 2,
                          "controls-position": "right",
                          controls: false
                        },
                        on: { change: _vm.amountChangeHandler },
                        model: {
                          value: _vm.splitChargeDialog.splitCharge.amount,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.splitChargeDialog.splitCharge,
                              "amount",
                              $$v
                            )
                          },
                          expression: "splitChargeDialog.splitCharge.amount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item-w",
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_TaxExcludedPriceP")
                      }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "excludingTaxAmount",
                          precision: 2,
                          min: -99999999,
                          max: 99999999,
                          "controls-position": "right",
                          disabled: true
                        },
                        model: {
                          value:
                            _vm.splitChargeDialog.splitCharge
                              .excludingTaxAmount,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.splitChargeDialog.splitCharge,
                              "excludingTaxAmount",
                              $$v
                            )
                          },
                          expression:
                            "splitChargeDialog.splitCharge.excludingTaxAmount"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "el-form-item-wrapper" },
                [
                  _c("el-form-item", { attrs: { label: " " } }),
                  _c("el-form-item", { attrs: { label: " " } }),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item-w",
                      attrs: { label: _vm.$t("CargoMsg.Cargo_TaxAmountP") }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "taxAmount",
                          precision: 2,
                          min: -99999999,
                          max: 99999999,
                          "controls-position": "right",
                          disabled: true
                        },
                        model: {
                          value: _vm.splitChargeDialog.splitCharge.taxAmount,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.splitChargeDialog.splitCharge,
                              "taxAmount",
                              $$v
                            )
                          },
                          expression: "splitChargeDialog.splitCharge.taxAmount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item-w",
                      attrs: { label: _vm.$t("CargoMsg.Cargo_TaxRateP") }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "taxRate",
                          precision: 2,
                          min: -99999999,
                          max: 99999999,
                          "controls-position": "right",
                          disabled: true
                        },
                        model: {
                          value: _vm.splitChargeDialog.splitCharge.taxRate,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.splitChargeDialog.splitCharge,
                              "taxRate",
                              $$v
                            )
                          },
                          expression: "splitChargeDialog.splitCharge.taxRate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    position: "absolute",
                    left: "0",
                    "padding-left": "10px"
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "onlyChangeQuantity" },
                      on: { change: _vm.onlyChangeQuantityChangeHandler },
                      model: {
                        value: _vm.splitChargeDialog.onlyChangeQuantity,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.splitChargeDialog,
                            "onlyChangeQuantity",
                            $$v
                          )
                        },
                        expression: "splitChargeDialog.onlyChangeQuantity"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "Invoice.invoice_SplitChargeOnlyChangeQuantity"
                          )
                        )
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    no: "ok",
                    type: "primary",
                    disabled: _vm.splitChargeDialog.btnSplitEnable
                  },
                  on: { click: _vm.doSplitCharge }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.splitChargeDialog.show = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.specialDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_SpecialApproval2"),
            width: "580px",
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.specialDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "dialog-content" },
            [
              _c(
                "el-form",
                {
                  ref: "specialForm",
                  attrs: {
                    inline: true,
                    model: _vm.specialDialog,
                    "label-width": "100px",
                    "label-position": "right"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-top": "10px" },
                      attrs: { label: _vm.$t("CargoMsg.Application_Item") }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          "default-value": _vm.specialDialog.applyMatter,
                          "static-options": [{ code: "专项超过毛利2倍申请" }],
                          filterable: "",
                          "tag-name": "code",
                          "tag-value": "code",
                          disabled: true,
                          cache: false
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-top": "20px" },
                      attrs: { label: _vm.$t("CargoMsg.Application_Reason") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: { type: "textarea", rows: 4 },
                        model: {
                          value: _vm.specialDialog.applyReason,
                          callback: function($$v) {
                            _vm.$set(_vm.specialDialog, "applyReason", $$v)
                          },
                          expression: "specialDialog.applyReason"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-top": "20px" },
                      attrs: { label: _vm.$t("Pricing.Attachment") }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "upload-file-row",
                          staticStyle: { "margin-left": "40px" }
                        },
                        [
                          _vm.hasUploadedSpecialFile()
                            ? [
                                _c(
                                  "span",
                                  { staticClass: "upload-file-name" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.getSpecialUploadedFileName())
                                    )
                                  ]
                                ),
                                _c("el-button", {
                                  staticClass: "upload-file-remove",
                                  attrs: {
                                    type: "text",
                                    icon: "el-icon-close"
                                  },
                                  on: { click: _vm.handleRemoveSpecialUpload }
                                })
                              ]
                            : _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function($event) {
                                      _vm.cloudFile.visible = true
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("CargoMsg.Action_AddAttachment")
                                      ) +
                                      " "
                                  )
                                ]
                              )
                        ],
                        2
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { "text-align": "center", "margin-top": "20px" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "ok", type: "primary" },
                      on: { click: _vm.doApproval }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "cancel" },
                      on: {
                        click: function($event) {
                          _vm.specialDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("cargo-cloud-file-upload", {
        attrs: {
          visible: _vm.cloudFile.visible,
          job: _vm.cloudFile.job,
          lob: _vm.cloudFile.lob
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cloudFile, "visible", $event)
          },
          uploadDone: function(data) {
            _vm.uploadSuccess(data)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }